module.exports = __webpack_public_path__ + "img/consult_bg.e54fd274.png";